import React from 'react';
import { Typography } from '@material-ui/core';
import InfoBox from '../InfoBox/InfoBox';

import styles from './SectionTitle.module.scss';

const SectionTitle = ({ title, children, infoStyle, iconPosition }) => (
  <div className={styles.sectionTitle}>
    <Typography variant="h6">{title}</Typography>

    <div
      className={styles.icon}
      style={
        iconPosition === 'top'
          ? { top: 6 }
          : iconPosition === 'bottom'
          ? { bottom: 6 }
          : undefined
      }
    >
      <InfoBox>
        <div style={{ maxWidth: 200, ...(infoStyle || {}) }}>{children}</div>
      </InfoBox>
    </div>
  </div>
);

export default SectionTitle;
